/** Impl dos use cases de DocumentoEmissao. @since G.5.4 */
import type { DocumentoEmitido, EmitirDocumentoCommand } from '@/domain/model/DocumentoEmitido';
import type { DocumentoEmissaoGateway } from '@/application/port/out/DocumentoEmissaoGateway';
import type {
  ListDocumentosEmitidosByAlunoUseCase, GetDocumentoEmitidoUseCase, EmitirDocumentoUseCase,
} from '@/application/port/in/DocumentoEmissaoUseCase';

export class ListDocumentosEmitidosByAluno implements ListDocumentosEmitidosByAlunoUseCase {
  constructor(private readonly g: DocumentoEmissaoGateway) {}
  execute(alunoId: string): Promise<DocumentoEmitido[]> { return this.g.listByAluno(alunoId); }
}
export class GetDocumentoEmitido implements GetDocumentoEmitidoUseCase {
  constructor(private readonly g: DocumentoEmissaoGateway) {}
  execute(id: string): Promise<DocumentoEmitido> { return this.g.get(id); }
}
export class EmitirDocumento implements EmitirDocumentoUseCase {
  constructor(private readonly g: DocumentoEmissaoGateway) {}
  execute(cmd: EmitirDocumentoCommand): Promise<DocumentoEmitido> { return this.g.emitir(cmd); }
}
